<template>
  <div class="certificate-scene" ref="box">
    <div class="certificate-scene__photo" :style="{ transform: fit }">
      <img
        alt=""
        class="certificate-scene__layer"
        decoding="async"
        :height="CERTIFICATE_SIZE.height"
        :src="CERTIFICATE_PHOTO"
        :width="CERTIFICATE_SIZE.width"
      >
      <div
        aria-hidden="true"
        class="certificate-scene__sheet"
        :style="{ transform: SHEET }"
      >
        <p class="certificate-scene__heading">
          {{ heading }}
          <span
            class="certificate-scene__name"
            :style="{ fontSize: `${nameSize(name)}px` }"
            v-text="name"
          />
        </p>
        <p class="certificate-scene__thanks" v-if="thanks" v-text="thanks" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { onBeforeUnmount, onMounted, ref } from "vue";
  import { coverFit } from "../../highlights/book-scene";
  import {
    CERTIFICATE_FOCUS,
    CERTIFICATE_PHOTO,
    CERTIFICATE_SIZE,
    nameSize,
    sheetTransform,
  } from "../../highlights/certificate-scene";

  /** The certificate a gift gives, with the page's own name on it. */
  const props = defineProps<{
    /** "Till minne av" / "Til minde om". */
    heading: string;
    name: string;
    /** The fund's thanks, as the certificate words it. */
    thanks: string;
    /** How far in on the photo; 1 crops it as the static image was. */
    zoom: number;
  }>();

  const SHEET = sheetTransform();

  const box = ref<HTMLElement | null>(null);
  const fit = ref("");

  function refit() {
    const el = box.value;
    if (el?.clientWidth && el.clientHeight) {
      fit.value = coverFit(
        el.clientWidth,
        el.clientHeight,
        props.zoom,
        CERTIFICATE_SIZE,
        CERTIFICATE_FOCUS
      );
    }
  }

  let observer: ResizeObserver | undefined;
  onMounted(() => {
    refit();
    if (box.value && typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(refit);
      observer.observe(box.value);
    }
  });
  onBeforeUnmount(() => observer?.disconnect());
</script>
